import type { FC } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import settings from 'src/settings';

interface AuthErrorProps {
  showAuthError?: boolean;
}

const AuthError: FC<AuthErrorProps> = ({ showAuthError = false }) => {
  const { t } = useTranslation('login');

  return (
    <>
      {showAuthError && t('authErrorMessage')}
      {!!settings.VITE_APP_LOGIN_ERROR_HELP_URL && (
        <a
          rel="noopener noreferrer"
          href={settings.VITE_APP_LOGIN_ERROR_HELP_URL}
        >
          {settings.VITE_APP_LOGIN_ERROR_HELP_URL}
        </a>
      )}
    </>
  );
};

export default AuthError;
